// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-65f656be]:export{menuBg:#414146;menuText:#e0e3da;menuActiveText:#fffff3}.el-breadcrumb__inner[data-v-65f656be],.el-breadcrumb__inner a[data-v-65f656be]{font-weight:400!important}.app-breadcrumb.el-breadcrumb[data-v-65f656be]{display:inline-block;font-size:14px;line-height:50px;margin-left:8px}.app-breadcrumb.el-breadcrumb .no-redirect[data-v-65f656be]{color:#97a8be;cursor:text}", ""]);
// Exports
module.exports = exports;
